import * as React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { WatchlistQueryKeys } from 'services/clients/watchList';
import { Example } from './Example';
import { UploadContainerForm } from './UploadContainerForm';

export const UploadTab: React.FC = () => {
  const queryClient = useQueryClient();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div>
        <h2 className="mb-3">Upload multiple containers with the Ocean Bill of Lading</h2>
        <UploadContainerForm
          onTrackAndTrace={() => {
            queryClient.invalidateQueries(['watchList']);
            queryClient.invalidateQueries(['watchListCount']);
            queryClient.invalidateQueries([WatchlistQueryKeys.WatchedShipments]);
          }}
        />
      </div>
      <Example />
    </div>
  );
};
UploadTab.displayName = 'ShippersWatchlist.AddContainers.UploadTab';
